import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import './style/style.css';
import './style/responsiveness.css';
import './style/swimming.css';
import './components/Toast.css';
import Header from "./components/Header";
import Footer from "./components/Footer";
import Form from './components/Form';
import OfferPopup from './components/OfferPopup';
import TopOfferBar from './components/TopOfferBar';
import { ToastContainer, useToast } from './components/Toast';
import HOME from "./pages/HOME";
import ABOUTUS from "./pages/ABOUTUS";
import OUTDOOR from './pages/OUTDOOR';
import INDOOR from './pages/INDOOR';
import RESTURANT from './pages/RESTURANT';
import PACKAGES from './pages/PACKAGES';
import NEWS from './pages/NEWS';
import EVENTS from './pages/EVENTS';
import CONTACT from "./pages/CONTACTUS";
import MEMBERSHIP from "./pages/MEMBERSHIP";
import OFERTAT from "./pages/OFERTAT";


function App() {
  const location = useLocation();
  const hideForm = location.pathname === "/contact";
  const { toasts, removeToast } = useToast();

  return (
    <>
      <TopOfferBar />
      <Header />
      <Routes>
        <Route path="/" element={<HOME />} />
        <Route path="/about" element={<ABOUTUS />} />
        <Route path="/outdoor" element={<OUTDOOR />} />
        <Route path="/indoor" element={<INDOOR />} />
        <Route path="/hotel-restaurant" element={<RESTURANT />} />
        <Route path="/packages" element={<PACKAGES />} />
        <Route path="/news" element={<NEWS />} />
        <Route path="/events" element={<EVENTS />} />
        <Route path="/contact" element={<CONTACT />} />
        <Route path="/membership" element={<MEMBERSHIP />} />
        <Route path="/ofertat" element={<OFERTAT />} />
      </Routes>
      {!hideForm && <Form />}
      <Footer />
      <OfferPopup />
      <ToastContainer toasts={toasts} removeToast={removeToast} />
    </>
  );
}

export default function WrappedApp() {
  return (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
}
